import React from 'react';
import { Box } from '@mui/material';
import UseinKysytytkysymykset from '../../UseinKysytytkysymykset';
import MobileLegalFrame from './MobileLegalFrame';

export default function MobileFaq() {
  return (
    <MobileLegalFrame title="Usein kysytyt kysymykset">
      <Box sx={{ '& header': { display: 'none' }, mx: -1 }}>
        <UseinKysytytkysymykset />
      </Box>
    </MobileLegalFrame>
  );
}
